import React from 'react';
import PropTypes from 'prop-types';
import { IconStar } from '@americanexpress/dls-icons';

const MAX_STARS = 5;

const HotelStarRating = ({ rating }) => {
  if (typeof rating !== 'number' || !Number.isFinite(rating) || rating <= 0) {
    return null;
  }

  const starCount = Math.min(Math.max(Math.round(rating), 0), MAX_STARS);

  if (starCount === 0) {
    return null;
  }

  return (
    <div
      className="flex flex-align-center"
      role="img"
      aria-label={`${starCount}-star hotel`}
    >
      {Array.from({ length: starCount }, (_, index) => (
        <IconStar
          key={index}
          color="black"
          isFilled={true}
          size="sm"
        />
      ))}
    </div>
  );
};

HotelStarRating.propTypes = {
  rating: PropTypes.number,
};

export default HotelStarRating;
